/**
 * Shared date availability utilities
 * Used across TourPage, GroupTourPage, OtherTour
 * Preserves all business logic exactly
 */

import { handleAvailableDatesFormat, allDaysOfRange } from '../helpers';

// Strips time so both picker dates (local midnight) and UTC-parsed DB dates compare correctly
const normalizeToLocalMidnight = (d) => {
    const n = new Date(d);
    n.setHours(0, 0, 0, 0);
    return n;
};

export const checkDateAvailability = (date, data, availableDateRanges) => {
    if (!data) return false;

    const normalizedDate = normalizeToLocalMidnight(date);
    const dateMs = normalizedDate.getTime();

    // Normalize stored unavailable timestamps to local midnight to match picker's timezone
    const unAvailableMs = new Set(
        allDaysOfRange(handleAvailableDatesFormat(data?.un_available_dates || '{}'))
            .map(ts => normalizeToLocalMidnight(new Date(ts)).getTime())
    );

    // Use the pre-parsed array appended by Eloquent ($appends → available_weekdays_array).
    // data.available_weekdays is the raw JSON string and Array.isArray() on it is always false.
    const weekdays =
        Array.isArray(data.available_weekdays_array) && data.available_weekdays_array.length > 0
            ? data.available_weekdays_array
            : null;

    for (const range of availableDateRanges) {
        if (!range || !range.start || !range.end) continue;

        const rangeStart = normalizeToLocalMidnight(range.start);
        const rangeEnd   = normalizeToLocalMidnight(range.end);

        if (normalizedDate < rangeStart || normalizedDate > rangeEnd) continue;
        if (unAvailableMs.has(dateMs)) continue;

        if (weekdays !== null) {
            if (weekdays.indexOf(date.getDay()) !== -1) return true;
        } else {
            return true;
        }
    }

    return false;
};

export const processAvailableDates = (availableDates) => {
    if (!availableDates) return [];
    
    const ranges = handleAvailableDatesFormat(availableDates);
    if (ranges && ranges.length > 0) {
        return ranges;
    }
    
    return [];
};
